export default function maskCep(prop?: string): string {
    if (prop) {
        const toString = prop.toString()
        const value = toString
            .replace(/[^\d]+/gi, '')
            .split('')
            .join('')
        let number = ''
        const mask = '####-#####'.split('').reverse().join('')
        for (let x = 0, y = 0; x < mask.length && y < value.length; ) {
            if (mask.charAt(x) != '#') {
                number += mask.charAt(x)
                x++
            } else {
                number += value.charAt(y)
                y++
                x++
            }
        }
        const result = number.split('').join('')
        return result
    } else return ''
}
